module.exports = __webpack_public_path__ + "static/media/do.54782064.svg";